import { AttendanceEstimatedTime } from 'generated/resources/graphql'
import { keyBy } from 'lodash'
import { DeepPartial } from 'utility-types'

export type AggregatedEstimatedTime = Pick<
  AttendanceEstimatedTime,
  'minutes' | 'regularMinutes' | 'overtimeMinutes' | 'contractMinutes' | 'absencesMinutes'
>

class EstimatedTimes {
  static empty<T extends DeepPartial<AttendanceEstimatedTime>>(
    date: string
  ): Pick<T, keyof AttendanceEstimatedTime> {
    return {
      date: date,
      minutes: 0,
      regularMinutes: 0,
      overtimeMinutes: 0,
      contractMinutes: 0,
      absencesMinutes: 0,
    }
  }

  static estimatedTimesByDates = <T extends Pick<AttendanceEstimatedTime, 'date'>>(
    estimatedTimes: T[]
  ): { [key: string]: T } => {
    return keyBy(estimatedTimes, 'date')
  }

  static sum(
    estimatedTimes: Pick<
      AttendanceEstimatedTime,
      'minutes' | 'regularMinutes' | 'overtimeMinutes' | 'contractMinutes' | 'absencesMinutes'
    >[]
  ): AggregatedEstimatedTime {
    const initialValue = {
      minutes: 0,
      regularMinutes: 0,
      overtimeMinutes: 0,
      contractMinutes: 0,
      absencesMinutes: 0,
    }

    return estimatedTimes.reduce((sum, estimatedTime) => {
      sum.minutes += estimatedTime.minutes
      sum.regularMinutes += estimatedTime.regularMinutes
      sum.overtimeMinutes += estimatedTime.overtimeMinutes
      sum.contractMinutes += estimatedTime.contractMinutes
      sum.absencesMinutes += estimatedTime.absencesMinutes
      return sum
    }, initialValue)
  }
}

export default EstimatedTimes
